import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import { getProfilesWithDevicesCount } from "../../../store/profiles";
import { ButtonLink, ProfileCards } from "../../../components";
import { getProfilesLimit } from "../../../store/settings";
import { loadLogicalDevices } from "../../../store/devices";
import { getLogicalDevices } from "../../../store/root.selectors";
import { useLoadableSlice } from "../../../store/shared/withLoadingState";
import { useIntlTranslate } from "../../../hooks";
import { useMobileValue } from "../../../common/Responsive";

import "./MultipleContent.scss";

export const MultipleContent = () => {
  useLoadableSlice(loadLogicalDevices(), getLogicalDevices);

  const profiles = useSelector(getProfilesWithDevicesCount);
  const profilesLimit = useSelector(getProfilesLimit);
  const availableProfilesNumber = profilesLimit - profiles.length;
  const translate = useIntlTranslate();
  const buttonSize = useMobileValue("medium", "small");

  return (
    <div className="multiple-content">
      <h2>
        <FormattedMessage id={"profiles"} />
      </h2>
      {profiles.length > 1 && (
        <div className="multiple-content__add-device">
          <FormattedMessage id="have_a_new_computer_or_mobile_device" />
          <ButtonLink
            to={"/settings/devices"}
            aria-label={translate("aria_link_to_page", {
              linkText: translate("add_device"),
              pageName: translate("devices"),
            })}
            className={"multiple-content__add-device-button"}
            size={buttonSize}
            color={"primary"}
            variant={"outlined"}
          >
            <FormattedMessage id="add_device" />
          </ButtonLink>
        </div>
      )}
      <ProfileCards
        profiles={profiles}
        availableProfilesNumber={availableProfilesNumber}
      />
    </div>
  );
};
